<template>
  <div>
    <v-progress-circular :rotate="270" :size="size" :width="15" :value="percent" :color="color">
      {{ value }}
    </v-progress-circular>
    <div class="mt-2">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: "BaseSinglePie",

  props: {
    title: {
      type: String,
      required: true,
    },
    color: {
      type: String,
    },
    size: {
      type: Number,
      default: 100,
    },
    maxValue: {
      type: Number,
      default: 100,
    },
    value: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {};
  },

  computed: {
    percent() {
      return (this.value / this.maxValue) * 100;
    },
  },
};
</script>

<style scoped></style>
